import * as THREE from 'three'

const ORDER = 'XYZ' // pick one and stick to it
const { radToDeg, degToRad, euclideanModulo } = THREE.MathUtils

const wrapDeg = a => euclideanModulo(a + 180, 360) - 180
const snapDeg = (a, eps = 1e-3) => {
  if (Math.abs(a) < eps) return 0
  const d = 180 - Math.abs(a)
  if (d < eps) return a < 0 ? -180 : 180
  return a
}

// shift curr by multiples of 360 to be closest to prev
const unwrapNear = (prev, curr) => curr + 360 * Math.round((prev - curr) / 360)

/**
 * Read: Euler -> [degX,degY,degZ] that stays on the same branch as `prevDeg`.
 * This is the “clean array” you can show in your inputs.
 */
export function eulerToDegrees(euler, deg, eps = 1e-3) {
  // ensure consistent order for decomposition
  const e = new THREE.Euler(euler.x, euler.y, euler.z, euler.order || ORDER)

  let x = wrapDeg(radToDeg(e.x))
  let y = wrapDeg(radToDeg(e.y))
  let z = wrapDeg(radToDeg(e.z))

  // keep continuity with what the UI showed previously
  x = unwrapNear(deg[0], x)
  y = unwrapNear(deg[1], y)
  z = unwrapNear(deg[2], z)

  // final wrap & snap to keep UI tidy
  x = snapDeg(wrapDeg(x), eps)
  y = snapDeg(wrapDeg(y), eps)
  z = snapDeg(wrapDeg(z), eps)

  deg[0] = x
  deg[1] = y
  deg[2] = z

  return deg
}

/**
 * Write: [degX,degY,degZ] -> Euler (same ORDER).
 * Use this when you apply the UI values back to Three.
 */
export function degreesToEuler(deg, eul) {
  eul.set(degToRad(deg[0]), degToRad(deg[1]), degToRad(deg[2]), ORDER)
  return eul
}
